import { Box, CircularProgress } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { CustomExplain } from '../components/CustomExplain'
import { CustomTitle } from '../components/CustomTitile'
import { ExportButton } from '../components/ExportButton'
import { Footer } from '../components/Footer'
import { ImportButton } from '../components/ImportButton'
import { ModalConfirmDialog } from '../components/ModalConfirmDialog'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from '../hooks/useAuth'
import { useC204DeviceExport } from '../hooks/useC204DeviceExport'
import { useC205DeviceImport } from '../hooks/useC205DeviceImport'
import { useC901SignedUrlGet } from '../hooks/useC901SignedUrlGet'
import { useCloudStorage } from '../hooks/useCloudStorage'
import { validateImportFileSize } from '../util/FileSize'
import { LanguageContext } from '../util/LanguageContext'
import { SideMenu } from './SideMenu'

// インポート・エクスポート画面
export const ImportExport = () => {
  const auth = useAuth()
  const c204 = useC204DeviceExport()
  const c205 = useC205DeviceImport()
  const c901 = useC901SignedUrlGet()
  const cs = useCloudStorage()
  // 文字列変換用
  const translation = useContext(LanguageContext)
  // ダイアログ
  const [openDialog, setOpenDialog] = useState(false)
  const [errorDialog, setErrorDialog] = useState('')

  // ローディングステータス監視
  useEffect(() => {
    if (
      c204.loading === loadStatus.LOADING ||
      c205.loading === loadStatus.LOADING ||
      c901.loading === loadStatus.LOADING ||
      cs.loading === loadStatus.LOADING ||
      auth.loading === loadStatus.LOADING
    ) {
      auth.setIsDisable(true)
    } else {
      auth.setIsDisable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [c204.loading, c205.loading, c901.loading, auth.loading, cs.loading])

  const pattern = /.(zip)$/i
  // 拡張子チェック関数
  const extensionCheck = (file: string) => {
    const result = pattern.test(file)
    return result
  }
  // インポートハンドラ
  const ImportHandler = async (file: File) => {
    // ファイルサイズチェック
    if (!validateImportFileSize(file)) {
      setErrorDialog(errorMsg.IMPORT_FILE_SIZE_ERROR)
      setOpenDialog(true)
      return
    }
    // 拡張子チェック
    if (!extensionCheck(file.name)) {
      setErrorDialog(errorMsg.UNSUPPORTED_FILE_ERROR)
      setOpenDialog(true)
      return
    }

    // 署名付きURL取得
    const resultUrl = await c901.execSignedUrlGet()
    if (resultUrl.success) {
      // console.log("execSignedUrlGet successed.");
      const resultCs = await cs.execUploadFile(resultUrl.message!, file)
      if (resultCs.success) {
        // console.log("execUploadFile successed.");
        // デバイスインポート
        const result = await c205.execDeviceImport(
          auth.deviceId,
          // file,
          resultUrl.message!,
        )
        if (result.success) {
        } else {
          setErrorDialog(result.message!)
          setOpenDialog(true)
        }
      } else {
        setErrorDialog(resultCs.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(resultUrl.message!)
      setOpenDialog(true)
    }
  }
  // エクスポートハンドラ
  const ExportHandler = async () => {
    // デバイスエクスポート
    const result = await c204.execDeviceExport(auth.deviceId)
    if (result.success) {
      // console.log("execDeviceExport. ");
      const resultCs = await cs.execDownloadFile(result.info!.storage_path, result.info!.file_name)
      if (resultCs.success) {
        // console.log("execDownloadFile. ");
      } else {
        setErrorDialog(resultCs.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }

  const handleDialogClose = () => {
    setErrorDialog('')
    setOpenDialog(false)
  }

  return (
    <>
      {openDialog && (
        <ModalConfirmDialog
          open={openDialog}
          text={errorDialog}
          onClick={() => handleDialogClose()}
        />
      )}

      <Box sx={{ display: 'flex', p: 0 }}>
        <Box sx={{ p: 0, width: '338px', flexShrink: 0 }}>
          <SideMenu />
        </Box>
        <Box sx={{ flexGrow: 1 }} display="flex" flexDirection="column">
          <Box mt={13}>
            <CustomTitle>{translation['button_import']}</CustomTitle>
          </Box>
          <Box
            sx={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 9999,
            }}
          >
            {(c204.loading === loadStatus.LOADING ||
              c205.loading === loadStatus.LOADING ||
              c901.loading === loadStatus.LOADING ||
              cs.loading === loadStatus.LOADING ||
              auth.loading === loadStatus.LOADING) && <CircularProgress />}
          </Box>
          <Box>
            <CustomExplain>{translation['import_instructions']}</CustomExplain>
          </Box>
          <Box mt={2}>
            <ImportButton title={translation['button_title_device1']} onImport={ImportHandler}>
              {translation['button_import']}
            </ImportButton>
          </Box>
          <Box marginTop={8}>
            <CustomTitle>{translation['button_export']}</CustomTitle>
          </Box>
          <Box>
            <CustomExplain>{translation['export_instructions']}</CustomExplain>
          </Box>
          <Box mt={2}>
            <ExportButton title={translation['button_title_device1']} onExport={ExportHandler}>
              {translation['button_export']}
            </ExportButton>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  )
}
